import useSWR, { mutate as globalMutate } from "swr";
import { API } from "../utils/constants";
import { authFetcher } from "./fetcher";

/**
 * useAdminMenu — Fetches all admin menu items (including inactive).
 *
 * API: GET /api/admin/menu → AdminMenuItemDto[] (CON-002 §6)
 * Requires Bearer token (injected by Axios interceptor in useApi).
 *
 * @returns {{ items: Array, error: any, isLoading: boolean, mutate: Function }}
 */
export function useAdminMenu() {
  const { data, error, isLoading, mutate } = useSWR(
    API.ADMIN.MENU.LIST,
    authFetcher,
    { revalidateOnFocus: false }
  );

  return { items: data ?? [], error, isLoading, mutate };
}

/**
 * invalidateAdminMenu — Force-revalidates the admin menu SWR cache.
 * Call this after any POST/PUT/DELETE mutation.
 */
export const invalidateAdminMenu = () => globalMutate(API.ADMIN.MENU.LIST);
